import { writable } from "svelte/store";
import { customFetch } from "../customFetch";
import { railcarsUrl } from "../urls";

export const railcars = writable([]);
export const isFetching = writable(false);
export const error = writable(null);

export async function load() {
    isFetching.set(true);
    error.set(null);

    try {
        let response = await customFetch(railcarsUrl());

        let data = await response.json();

        railcars.set(data);
    } catch (e) {
        error.set(`Can't get actual railcars list from server: ${e.message}`);
    }

    isFetching.set(false);
}
